module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/cloud-infor-icon.6d4701a4.png";